module.exports = __webpack_public_path__ + "img/dog_silhouette_bg.f20286c1.svg";